import { View } from 'react-native';
import { AmpMaskViewProps } from './AmpMaskView.types';

export const AmpMaskView = ({ mask, ...props }: AmpMaskViewProps) => {
  return <View {...props} testID={mask === 'amp-mask' ? 'amp-block' : 'amp-unblock'} />;
};
